import { Component, Input, OnInit } from '@angular/core';
import { isIdentificadorMatriz, isIdentificadorFilial } from '../identificador-matriz-filial';

interface Config {
    isMatriz: boolean;
    isFilial: boolean;
}

@Component({
    selector: 'sgt-identificador-matriz-filial-input-group-text',
    templateUrl: './identificador-matriz-filial-input-group-text.component.html',
    styleUrls: ['./identificador-matriz-filial-input-group-text.component.less']
})
export class IdentificadorMatrizFilialInputGroupTextComponent implements OnInit {
    config: Config;
    @Input() identificador: number;
    @Input() prepend: boolean;
    @Input() append: boolean;

    ngOnInit(): void {
        this.setConfig();
    }

    private setConfig() {
        this.config = {
            isMatriz: isIdentificadorMatriz(this.identificador),
            isFilial: isIdentificadorFilial(this.identificador)
        };
    }
}
